import React, { useContext, useRef, useLayoutEffect, useEffect } from 'react';
import { ThemeProvider } from 'styled-components';
import BasicIcon from '../BasicIcon/BasicIcon';
import { ThemeContext } from '../ThemeProvider/ThemeProvider';
import { BodyContainer, ToastCotainer } from './styles';
import { aniamtion } from './Animations';
import { ToastIcon, ToastPropsType } from './types';

const Toast: React.FC<ToastPropsType> = ({ index, toast, toasts, deleteToast }) => {
  const { actualTheme } = useContext(ThemeContext);
  const toastRef = useRef();
  useLayoutEffect(() => {
    const ctx = aniamtion(toastRef);
    return () => ctx.revert();
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      if (toasts.length) {
        deleteToast();
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [toasts, deleteToast]);

  return (
    <ThemeProvider theme={actualTheme}>
      <ToastCotainer ref={toastRef} type={toast.type} index={index}>
        <BasicIcon
          name={ToastIcon[toast.type]}
          color={actualTheme.toast.types[toast.type].iconColor}
        />
        <BodyContainer>{toast.body}</BodyContainer>
      </ToastCotainer>
    </ThemeProvider>
  );
};

export default Toast;
